import * as React from 'react'
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { TooltipProvider } from '@/components/ui/misc'
import { useTheme } from '@/lib/theme'

export function Providers({ queryClient, children }: { queryClient: QueryClient; children: React.ReactNode }) {
  const { theme } = useTheme()
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={250}>
        {children}
        <Toaster
          position="bottom-right"
          theme={theme}
          richColors
          closeButton
          toastOptions={{ className: 'font-sans text-[13px]' }}
        />
      </TooltipProvider>
    </QueryClientProvider>
  )
}
